import axios from 'axios';
import type {
  IIsLegacyAnsweringProviderParams,
  IIsLegacyAnsweringProviderRequest,
} from '@/app-package';

const isLegacyAnsweringProvider = async (
  params: IIsLegacyAnsweringProviderParams,
) => {
  const config: IIsLegacyAnsweringProviderRequest = {
    url: `/answering_service/provides_legacy_service/${params.answeringOrgId}`,
    method: 'get',
  };

  const { data } = await axios.request<boolean>(config);
  return data;
};

export default isLegacyAnsweringProvider;
